import { appRoutes } from "../../routes/appRoutes";

export type WebSessionPayload = {
  access_token: string;
  active_workspace?: { id?: string }[];
};

export const isWebSessionPayload = (value: unknown): value is WebSessionPayload => {
  if (!value || typeof value !== "object") return false;
  const session = value as Partial<WebSessionPayload>;
  return (
    typeof session.access_token === "string" &&
    session.access_token.length > 0 &&
    session.access_token.length <= 20000 &&
    (session.active_workspace === undefined ||
      (Array.isArray(session.active_workspace) &&
        session.active_workspace.every(
          (workspace) =>
            !!workspace &&
            typeof workspace === "object" &&
            (workspace.id === undefined ||
              (typeof workspace.id === "string" && workspace.id.length <= 128)),
        )))
  );
};

export const getCurrentRelativeUrl = (location: Pick<Location, "pathname" | "search" | "hash">): string =>
  `${location.pathname}${location.search}${location.hash}`;

export const getWebLoginUrl = (
  appLoginOrigin: string,
  location: Pick<Location, "pathname" | "search" | "hash">,
): string => {
  const loginUrl = new URL("/", appLoginOrigin);
  const redirect = getCurrentRelativeUrl(location);
  if (location.pathname !== appRoutes.login && location.pathname !== "/auth/handoff") {
    loginUrl.searchParams.set("redirect", redirect);
  }
  return loginUrl.toString();
};
